<template>
  <div class="ex-home">
    <div class="eh-top">
      <div class="eh-top-l">
        <div class="logo">
          <img :src="company.logo" v-if="company.logo" />
          <img src="@assets/img/empty.png" v-else />
        </div>
        <div class="info">
          <div class="info-title">{{ company.name }}</div>
          <div class="info-txt" v-if="boothInfoComputed[0].Hall || boothInfoComputed[0].Code">
            展位号：
            <span v-for="(booth, i) in boothInfoComputed" :key="'booth-' + i">
              {{ booth.Hall || "" }}<template v-if="booth.Hall">-</template
              >{{ booth.Code }}
              <span
                v-if="booth.Hall && booth.Code && i !== boothInfoComputed.length - 1"
                >,</span
              >
            </span>
          </div>
          <span @click="linkTo('comp')" class="info-edit">修改</span>
        </div>
      </div>
      <div class="eh-top-r">
        <Dropdown trigger="click">
          <div class="ex-select">您好，欢迎参展{{ exhibition.name }}</div>

          <i class="icon iconfont icon-xiala"> </i>

          <DropdownMenu slot="list">
            <DropdownItem v-for="(item1, index) in exList" :key="index">
              <div @click="checkEx(index)">{{ item1.name }}</div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <p v-if="dateType === 1">
          距开展还有
          <span>{{ dateCount }}</span
          >天
        </p>
        <p v-if="dateType === 2">正在开展</p>
        <p v-if="dateType === 3">展会已结束</p>
      </div>
    </div>
    <div class="eh-content" style="padding-top: 34px">
      <Row :gutter="30">
        <Col
          :md="12"
          :xl="8"
          :xxl="6"
          v-for="(item, index) in [1, 1, 1, 1]"
          :key="'releaseInt-' + index"
          class="w-20"
        >
          <!-- 项目 -->
          <div class="addPro pro" v-if="index == 0">
            <h3>您需要完成的项目</h3>
            <span @click="linkView">点击查看</span>
            <p v-if="ComFinish && ComFinish.unfinishedCount > 0">
              {{ ComFinish.unfinishedCount }}项未完成
            </p>
          </div>
          <!-- 公司主页 -->
          <div class="pro" v-if="index == 1">
            <div class="pro-top" @click="linkTo('comp')">
              公司主页
              <i class="icon iconfont icon-xiala"></i>
            </div>
            <div class="pro-bot comp-bot">
              <div class="comp-msg comp-msg-t" style="width: 100%">
                <h4 v-if="homeMsg">
                  {{
                    homeMsg.viewCount > 9999
                      ? Math.floor(homeMsg.viewCount / 1000) / 10 + "W"
                      : homeMsg.viewCount
                  }}
                </h4>
                <h4 v-else>0</h4>
                <span>浏览量</span>
              </div>
              <div class="comp-msg">
                <h4 v-if="homeMsg">
                  {{
                    homeMsg.userCount > 9999
                      ? Math.floor(homeMsg.userCount / 1000) / 10 + "W"
                      : homeMsg.userCount
                  }}
                </h4>
                <h4 v-else>0</h4>
                <span>访客量</span>
              </div>
              <div class="comp-msg">
                <h4 v-if="homeMsg">
                  {{
                    homeMsg.followCount > 9999
                      ? Math.floor(homeMsg.followCount / 1000) / 10 + "W"
                      : homeMsg.followCount
                  }}
                </h4>
                <h4 v-else>0</h4>
                <span>关注量</span>
              </div>
              <!-- <div class="comp-msg">
                <h4
                  v-if="homeMsg"
                >{{ homeMsg.commentCount > 9999 ? (Math.floor(homeMsg.commentCount/1000)/10) + 'W' : homeMsg.commentCount}}</h4>
                <h4 v-else>0</h4>
                <span>留言数</span>
              </div> -->
            </div>
          </div>
          <!-- 产品信息 -->
          <div class="pro" v-if="index == 2">
            <div class="pro-top" @click="linkTo('pro')">
              产品信息
              <i class="icon iconfont icon-xiala"></i>
            </div>
            <div class="pro-bot hPro-bot">
              <div class="hPro-bot-c">
                <div class="hPro-bot-c-l">{{ proMsg ? proMsg.count : 0 }}</div>
                <div class="hPro-bot-c-r">
                  <p>
                    <span>{{
                      tagCounts ? Object.keys(tagCounts)[0] : ""
                    }}</span>
                    {{ proMsg ? tagCounts[Object.keys(tagCounts)[0]] : 0 }}
                  </p>
                  <p>
                    <span>{{
                      tagCounts ? Object.keys(tagCounts)[1] : ""
                    }}</span>
                    {{ proMsg ? tagCounts[Object.keys(tagCounts)[1]] : 0 }}
                  </p>
                </div>
              </div>
              <div class="hPro-bot-t">
                <div class="t-li">
                  <span>访客</span>
                  <span>{{ proMsg ? proMsg.viewCount : 0 }}人</span>
                </div>
                <div
                  class="t-li t-li-c"
                  @click="linkProMes"
                  style="cursor: pointer"
                >
                  <span>留言</span>
                  <span>{{ proMsg ? proMsg.commentCount : 0 }}条</span>
                </div>
                <div class="t-li">
                  <span>分享</span>
                  <span>{{ proMsg ? proMsg.shareCount : 0 }}次</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 活动信息 -->
          <div class="pro" v-if="index == 3">
            <div class="pro-top" @click="linkTo('act')">
              活动信息
              <i class="icon iconfont icon-xiala"></i>
            </div>
            <div class="pro-bot hPro-bot">
              <div class="hPro-bot-c">
                <div class="hPro-bot-c-l">{{ actMsg ? actMsg.count : 0 }}</div>
                <div class="hPro-bot-c-r">
                  <!-- <p>
                    <span>进行中</span>
                    {{actMsg ? actMsg.processingCount : 0}}
                  </p>
                  <p>
                    <span>已完成</span>
                    {{actMsg ? actMsg.completedCount : 0}}
                  </p> -->
                  <span>将展示在小程序和观众中心</span>
                </div>
              </div>
              <div class="hPro-bot-t">
                <div class="t-li">
                  <span>访客</span>
                  <span>{{ actMsg ? actMsg.viewCount : 0 }}人</span>
                </div>
                <div
                  class="t-li t-li-c"
                  @click="linkActMes"
                  style="cursor: pointer"
                >
                  <span>留言</span>
                  <span>{{ actMsg ? actMsg.commentCount : 0 }}条</span>
                </div>
                <div class="t-li">
                  <span>分享</span>
                  <span>{{ actMsg ? actMsg.shareCount : 0 }}次</span>
                </div>
              </div>
            </div>
          </div>
        </Col>

        <Col :md="12" :xl="8" :xxl="6" class="w-20">
          <div class="pro">
            <div class="pro-top" @click="linkTo('liveZ')">
              直播通知
              <div style="color: #2d8cf0; font-size: 14px">前往直播</div>
            </div>
            <div class="pro-bot hPro-bot">
              <div class="hPro-bot-c" style="margin-left: 35%">
                <div class="hPro-bot-c-l" style="width: 15%">
                  {{ totalCount }}
                </div>
                <div class="hPro-bot-c-r">
                  <span>直播总数</span>
                </div>
              </div>
              <div class="hPro-bot-t">
                <div class="t-li">
                  <span>审核通过</span>
                  <span>{{ listPass ? listPass.length : 0 }}</span>
                </div>
                <div
                  class="t-li t-li-c"
                  @click="liveBroadcastModel = true"
                  style="cursor: pointer"
                >
                  <span style="color: #2d8cf0">被驳回</span>
                  <span style="color: #2d8cf0">{{
                    list ? list.length : 0
                  }}</span>
                </div>
                <div class="t-li">
                  <span>即将开始</span>
                  <span>{{ listStarted ? listStarted.length : 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </Col>

        <template v-if="ComFinish && ComFinish.items">
          <Col
            :md="12"
            :xl="8"
            :xxl="6"
            v-for="(item, index) in ComFinish.items"
            :key="'item' + index"
            class="w-20"
          >
            <!-- 项目信息 -->
            <div class="pro">
              <div class="pro-top" @click="linkToPro(item)">
                {{ item.name }}
                <i class="icon iconfont icon-xiala"></i>
              </div>
              <div class="pro-bot common-bot">
                <img src="@/assets/img/home-n.png" v-if="item.stateId == 0" />
                <img src="@/assets/img/home-n.png" v-if="item.stateId == -1" />
                <img src="@/assets/img/home-s.png" v-if="item.stateId == 1" />
                <span class="type-1" v-if="item.stateId == 0">进行中</span>
                <span class="type-2" v-if="item.stateId == -1">未提交</span>
                <span class="type-2" v-if="item.stateId == 1">已提交</span>
                <p v-if="item.stateId == 1" style="color: #333">
                  {{ item.introduction }}
                </p>
                <p v-if="item.stateId !== 1 && item.stopTime">
                  {{ item.stopTime | moment("YYYY/MM/DD") }} 截止
                </p>
              </div>
            </div>
          </Col>
        </template>
      </Row>
    </div>
    <iModal
      v-model="infoTip"
      width="700"
      :closable="false"
      footer-hide
      class-name="info-Tip"
    >
      <p class="tip">欢迎进入</p>
      <p class="tip">{{ exhibition.shortName }}展商填报系统</p>
      <p class="tip">请完善您的企业信息</p>
      <div
        style="position: relative; width: 100%; height: 40px; margin-top: 30px"
      >
        <p
          class="tip-btn"
          @click="$router.push('/exhibition/index/companyInfo')"
        >
          点击前往
        </p>
      </div>
    </iModal>

    <iModal v-model="votingActivities" width="700" footer-hide>
      <div class="dis_column">
        <p style="font-size: 36px; margin-top: 40px">立即完善英文信息</p>
        <p style="font-size: 20px; margin: 40px 0">
          为企业、产品提高海外曝光度
        </p>
        <Button
          type="error"
          style="background-color: rgba(209, 49, 25, 1); margin-bottom: 40px"
          @click="$router.push('/exhibition/index/product/allpro')"
          >立即前往</Button
        >
      </div>
    </iModal>

    <el-dialog
      :visible.sync="newPassword"
      width="800"
      center
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="dis_column">
        <p style="font-size: 16px; margin: 20px 0">
          密码均应在8位以上，并具有大小写字母、数字、符号等至少两种以上的组合
        </p>
        <!-- <p style="font-size: 36px;margin-top: 40px;">立即修改密码</p>
        <p style="font-size: 20px;margin: 40px 0;">密码均应在8位以上，并具有大小写字母、数字、符号等至少两种以上的组合</p>
        <Button type="error" style="background-color: rgba(209, 49, 25, 1);margin-bottom: 40px;" 
        @click="$router.push('/exhibition/index/companyAccount')">立即前往</Button> -->
        <changePassword @closed="closed"></changePassword>
      </div>
    </el-dialog>

    <changePhone :show="showPhone" @finish="finishPhone()" @close="showPhone = false" />


    <!-- 直播通知 -->
    <iModal
      :title="liveBroadcastTitle"
      v-model="liveBroadcastModel"
      class-name="vertical-center-modal"
      width="800px"
      :mask-closable="false"
    >
      <Table :columns="columns" :data="list" style="min-height: 500px">
        <template slot-scope="{ row }" slot="Name">{{ row.name }}</template>

        <template slot-scope="{ row }" slot="apply">
          <Poptip trigger="hover" word-wrap :content="row.liveAuditRemark">
            <span>{{ row.liveAuditRemark }}</span>
          </Poptip>
        </template>

        <template slot-scope="{ row }" slot="edit">
          <a href="javascript:;" @click="changeLive(row)">去修改</a>
        </template>
      </Table>

      <div slot="footer">
        <Button type="primary" @click="liveBroadcastHandle()">确定</Button>
        <Button @click="liveBroadcastModel = false">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import changePassword from "./components/changePassword";
import changePhone from "./components/changePhone";
export default {
  name: "exhibition-home",
  data() {
    return {
      totalCount: 0,
      liveBroadcastTitle: "被驳回",
      liveBroadcastModel: false,
      columns: [
        {
          title: "活动名称",
          slot: "Name",
          align: "center",
        },
        {
          title: "驳回原因",
          slot: "apply",
          align: "center",
        },

        {
          title: "操作",
          slot: "edit",
          align: "center",
        },
      ],
      list: [],
      listPass: [],
      listStarted: [],

      dateType: 0, // 开展的状态 1 还未开展 2 正在开展 3已经开过展
      dateCount: 0, // 距离开展天数
      homeMsg: null,
      proMsg: null,
      actMsg: null,
      tagCounts: {},
      ComFinish: null,
      infoTip: false,
      votingActivities: false,
      newPassword: false,
      userId: "",
      exList: [],

            adminInfo: null, // 管理员信息
            showPhone: false, // 是否弹出修改手机号弹窗

    };
  },
  components: {
    changePassword,
    changePhone
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo",
      ExhibitionIdArr: "getExhibitionIdArr",
    }),

    header() {
      return this.$store.state.header;
    },
    boothInfoComputed() {
      if (
        this.joinInfo &&
        this.joinInfo.boothInfo &&
        this.joinInfo.boothInfo.length
      ) {
        // if (
        //   Object.prototype.toString.call(this.joinInfo.boothInfo) ===
        //   "[object String]"
        // ) {
        //   if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
        //     this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
        //   }
        // }
        if (
          Object.prototype.toString.call(this.joinInfo.boothInfo) ===
          "[object Object]"
        ) {
          return [
            {
              Hall: this.joinInfo.boothInfo.Hall,
              Code: this.joinInfo.boothInfo.Code,
            },
          ];
        }
        if (
          Object.prototype.toString.call(this.joinInfo.boothInfo) ===
          "[object Array]"
        ) {
          return [
            {
              Hall: this.joinInfo.boothInfo[0].Hall,
              Code: this.joinInfo.boothInfo[0].Code,
            },
          ];
        }
      }
      return [{ Hall: "", Code: "" }];
    },

    option() {
      return {
        size: 999,
        page: 1,
        // exhibitionId:this.exhibition.id,
        compId: this.company.id,
        isApplyLive: true,
      };
    },
  },
  mounted() {

       if (this.joinInfo && this.joinInfo.boothInfo && this.joinInfo.boothInfo.length) {
        if (
          Object.prototype.toString.call(this.joinInfo.boothInfo) === "[object String]"
        ) {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
        }
      }

    this.initLiveBroadcast();
    this.getData();
    this.getHomeMsg2();
    this.getComProcess();
  },
  async created() {
    
    await this.getAllConfiSettle("exhibition");
    this.getEx();
    document.title = "中国国际医疗器械博览会 - 首页";

    if (!this.company.businessLicenses || !this.company.logo) {
      this.infoTip = true;
    }

    // let password = localStorage.getItem("password");
    // const regex =
    //   /^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*\d)(?=.*[\W_])|(?=.*[A-Z])(?=.*\d)(?=.*[\W_])).{8,}$/;
    // if (!regex.test(password)) {
    localStorage.removeItem("password");
    const pwdStrengthPassed = localStorage.getItem("pwdStrengthPassed");
    if (pwdStrengthPassed !== "1") {
      this.newPassword = true;
      this.votingActivities = false;
    } else {
        if(await this.isBindPhone()){
            this.showPhone = true;
        }
      this.votingActivities = true;
      this.newPassword = false;
    }
  },
  methods: {
    ...mapActions({
      getAllConfiSettle: "getAllConfiSettle",
      getHomeMsg: "loginModule/getHomeMsg",
      getCompany: "loginModule/getCompany",
      getExhibitionById: "exhibitionModule/getExhibitionById",
      getExIdByUserId: "loginModule/getExIdByUserId",
      getJoinInfo: "loginModule/getJoinInfo",
      GetExhibitionByCompany: "loginModule/GetExhibitionByCompany",
      SwitchDefaultJoin: "loginModule/SwitchDefaultJoin",
      getActivityLiveQuery: "liveModule/getActivityLiveQuery",
      getStaffByCompId: "companyModule/getStaffByCompId",

    }),
    ...mapMutations({
      setCompany: "loginModule/setCompany",
      setExhibition: "loginModule/setExhibition",
      setExhibitionCurrent: "loginModule/setExhibitionCurrent",
      setJoinInfo: "loginModule/setJoinInfo",
    }),
    async closed(res) {
      this.newPassword = false;
      // localStorage.setItem("password", res);
      localStorage.setItem("pwdStrengthPassed", "1");
      localStorage.removeItem("password");
      this.$Message.success("修改成功，请重新登录！");

       if(await this.isBindPhone()){
            this.showPhone = true;
            return
        }

      // setTimeout(() => {
      //   location.href = "/exhibition/login/alogin";
      // }, 500);
    },


    // 是否绑定手机号或者邮箱
   async isBindPhone() {
    let staffArr = await this.getStaffByCompId(this.company.id);
    staffArr.forEach((c) => {
        if (c.userId === this.user.id) {
            this.adminInfo = c;
        }
    });
    // 如果adminInfo存在，且手机号和邮箱都未绑定，则返回true（需要弹窗）
    if (this.adminInfo && !this.adminInfo.phoneNumber && !this.adminInfo.email) {
        return true;
    } else {
        return false;
    }
},
    finishPhone(){},
   


    // 直播统计
    async initLiveBroadcast() {
      this.list = [];
      this.listPass = [];
      this.listStarted = [];
      let proData = await this.getActivityLiveQuery(this.option);
      if (proData) {
        this.totalCount = proData.totalCount;
        let date = new Date(),
          year = date.getFullYear(), //获取完整的年份(4位)
          month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
          strDate = date.getDate(); // 获取当前日(1-31)
        const HH =
          new Date().getHours() < 10
            ? "0" + new Date().getHours()
            : new Date().getHours();
        const mm =
          new Date().getMinutes() < 10
            ? "0" + new Date().getMinutes()
            : new Date().getMinutes();
        const ss =
          new Date().getSeconds() < 10
            ? "0" + new Date().getSeconds()
            : new Date().getSeconds();

        if (month >= 1 && month <= 9) month = "0" + month; // 如果月份是个位数，在前面补0
        if (strDate >= 0 && strDate <= 9) strDate = "0" + strDate; // 如果日是个位数，在前面补0

        let currentTime = `${year}-${month}-${strDate} ${HH}:${mm}:${ss}`;
        const time1 = new Date(currentTime);

        proData.items.map((item,) => {
          if (item.liveAudit == "notpass") {
            this.list.push(item);
          }
          if (item.liveAudit == "pass") {
            this.listPass.push(item);
          }

          const time2 = new Date(item.liveStartTime);
          // 直播开始以后  就不计算即将开始
          if (time2 > time1) {
            const diffInMilliseconds = Math.abs(
              time2.getTime() - time1.getTime()
            );
            const diffInHours = diffInMilliseconds / (1000 * 60 * 60);
            if (diffInHours <= 12) {
              this.listStarted.push(item);
            }
          }
        });
      }
    },

    // 跳转到  修改直播详情页
    changeLive() {
      // this.$router.push(`/exhibition/index/activity/editpro?id=`+(e.id));
      this.$router.push(`/exhibition/index/activity/allpro`);
    },

    linkView() {
      if (this.ComFinish && this.ComFinish.count > 0) {
        this.$router.push({ name: "home-pro" });
      } else {
        this.$Message.info("暂无项目！");
      }
    },
    getHomeMsg2() {
      this.getHomeMsg(this.joinInfo.joinId).then((res) => {
        if (res) {
          this.homeMsg = res;
          this.proMsg = res.productCount;
          this.actMsg = res.activityCount;
          if (res.productCount.tagCounts != null) {
            this.tagCounts = res.productCount.tagCounts;
          }
        }
      });
    },
    getComProcess() {
      // 获取公司的完成进度
      this.$http
        .get(
          `/api/join/GetFinishItems?joinId=${this.joinInfo.joinId}`,
          this.header
        )
        .then((res) => {
          if (res.status === 200 && res.data) {
            this.ComFinish = res.data;
            // console.log("公司完成情况：",this.ComFinish);
          }
        });
    },
    linkTo(type) {
      switch (type) {
        case "comp":
          this.$router.push("/exhibition/index/companyInfo");
          break;
        case "pro":
          this.$router.push("/exhibition/index/product/allpro");
          break;
        case "act":
          this.$router.push("/exhibition/index/activity/allpro");
          break;
        case "cat":
          this.$router.push("/exhibition/index/exinfo/catalogue");
          break;
        case "car":
          this.$router.push("/exhibition/index/exinfo/carApply");
          break;
        case "invoice":
          this.$router.push("/exhibition/index/exinfo/invoice");
          break;
        case "link":
          this.$router.push("/exhibition/index/companyInfo?type=link");
          break;
        case "liveZ":
          this.$router.push("/exhibition/index/activity/allpro?type=all");
          break;
      }
    },
    linkToPro(item) {
      // 根据finishType字段，跳转至不同页面
      // Embellish = 11：个性化设置提示
      // Release = 12：发布商机提示
      // Product = 13：上传产品提示
      // Activity = 14：申请活动提示
      // Catalogue = 15：提交会刊提示
      // Lintel = 16：提交楣板信息提示,
      // Vehicle = 17：申请车证提示
      // Company = 18：完善公司信息提示
      // Contact = 19：完善联系人提示
      // Invoice = 20：完善开票信息提示
      // Example = 21：上传案例提示
      // Brand = 22：上传品牌提示
      // Cooperation = 23：上传合作伙伴提示
      if (item.finishType) {
        switch (item.finishType) {
          case 11:
            this.$router.push("/exhibition/index/exinfo/exhibition-info");
            break;
          case 12: // 商机
            break;
          case 13:
            this.$router.push("/exhibition/index/product/allpro");
            break;
          case 14:
            this.$router.push("/exhibition/index/activity/allpro");
            break;
          case 15:
            this.$router.push("/exhibition/index/exinfo/catalogue");
            break;
          case 16:
            this.$router.push("/exhibition/index/exinfo/fascia-board");
            break;
          case 17:
            this.$router.push("/exhibition/index/exinfo/carApply");
            break;
          case 18:
            this.$router.push("/exhibition/index/companyInfo?type=basic");
            break;
          case 19:
            this.$router.push("/exhibition/index/companyInfo?type=link");
            break;
          case 20:
            this.$router.push("/exhibition/index/exinfo/invoice");
            break;
          case 21:
            this.$router.push("/exhibition/index/case/all");
            break;
          case 22:
            this.$router.push("/exhibition/index/brand/allbrand");
            break;
          case 23:
            this.$router.push("/exhibition/index/partner/allpartner");
            break;
        }
      }
    },
    getData() {
      const todady = new Date().getTime(); // 当前时间戳
      const StartDate = this.exhibition
        ? new Date(this.exhibition.startTime).getTime()
        : 0; // 展会开始时间
      const EndDate = this.exhibition
        ? new Date(this.exhibition.endTime).getTime() + 24 * 3600 * 1000
        : 0; // 展会结束时间
      const date = EndDate - todady; // (结束-当前)
      const date2 = StartDate - todady; // (开始-当前)
      if (date < 0) {
        this.dateCount = -1; //
        this.dateType = 3; // 展会已经举办
      }
      if (date2 < 0 && date > 0) {
        // 正在开展
        this.dateType = 2;
      }
      if (date2 > 0) {
        // 还未开展
        this.dateType = 1;
        this.dateCount = Math.ceil(date2 / (24 * 3600 * 1000)); // 距离开展还有多少天
        // console.log(date2 / (24 * 3600 * 1000),'倒计时时间');
      }
    },
    linkProMes() {
      this.$router.push("/exhibition/index/product/allpro?type=mes");
    },
    linkActMes() {
      this.$router.push("/exhibition/index/activity/allpro?type=mes");
    },
    async getEx() {
      let exList = await this.GetExhibitionByCompany(this.company.id);
      if (exList) {
        this.exList = exList;
      }
    },
    //切换展会
    async checkEx(e) {
      // if(e==0){
      //   this.userId='0d1fb2d9-b8ec-450c-6cab-08d8132cc475'
      // }else {
      //   this.userId='7B9F3176-0D83-4D01-6FD8-08D828BE940A'
      // }
      //
      // let company = await this.getCompany(this.userId);
      // if (!company) {
      //   // this.$router.push("/exhibition/register-company");
      //   this.$Message.warning("未绑定公司信息！");
      //   return;
      // }
      // else{
      //   this.setCompany(company);
      //   console.log("公司信息：", company);
      // let idInfo = await this.getExIdByUserId(this.userId);
      if (this.exList && this.exList[e].id) {
        if (this.ExhibitionIdArr.indexOf(this.exList[e].id) !== -1) {
          this.exhibitionId = this.exList[e].id;
          this.setExhibitionCurrent = this.exList[e];
          // let exhibition = await this.getDefaultJoinExhibition(company.id);
          let exData = await this.getExhibitionById(this.exhibitionId);
          this.setExhibition(exData);
          // console.log("展会信息：", exData);
          // this.setLogin(true);
          let joinInfo = await this.getJoinInfo({
            ExhibitionId: this.exhibitionId,
          });
          if (joinInfo) {
            this.setJoinInfo(joinInfo.info);
            let opt = {
              CompId: this.company.id,
              ExhibitionId: this.exhibitionId,
            };
             await this.SwitchDefaultJoin(opt);
            this.getData();
            this.getHomeMsg2();
            this.getComProcess();
            this.initLiveBroadcast();
          } else {
            this.$Message.warning("未绑定展会信息！");
          }
        } else {
          this.$Message.warning("未绑定展会信息！");
        }
      } else {
        this.$Message.warning("未绑定展会信息！");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ex-home {
  width: 100%;
  height: 120px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  padding: 27px 24px 0 24px;
  .eh {
    &-top {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      &-l {
        width: 50%;
        display: flex;
        align-items: center;
        .logo {
          width: 64px;
          height: 64px;
          border: 1px solid #d8d8d8;
          border-radius: 5px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          padding-left: 20px;
          position: relative;
          max-width: calc(100% - 100px);
          &-title {
            font-size: 18px;
            color: #333;
            font-weight: bold;
            margin-bottom: 10px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &-txt {
            font-size: 12px;
            color: #4d4d4d;
          }
          &-edit {
            position: absolute;
            right: -40px;
            top: 4px;
            font-size: 14px;
            color: #d13119;
            cursor: pointer;
          }
        }
      }
      &-r {
        width: 50%;
        position: relative;
        text-align: right;
        .ex-select {
          font-size: 18px;
          color: #333;
          font-weight: bold;
          text-align: right;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 20px;
          cursor: pointer;
        }
        i {
          position: absolute;
          right: 0;
          top: 0;
          color: #333;
          font-weight: bold;
          cursor: pointer;
        }
        p {
          font-size: 14px;
          color: #333;
          text-align: right;
          line-height: 28px;
          span {
            font-size: 18px;
          }
        }
      }
    }
    &-content {
      .pro {
        height: 290px;
        background-color: #fff;
        box-shadow: 0px 2px 6px 0px rgba(136, 156, 176, 0.1);
        margin-bottom: 24px;
      }
      .addPro {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h3 {
          font-size: 24px;
          line-height: 48px;
          color: #333;
        }
        span {
          display: block;
          width: 112px;
          height: 32px;
          background-color: #d13119;
          border-radius: 4px;
          line-height: 32px;
          color: #fff;
          font-size: 14px;
          margin: 30px auto 0;
          cursor: pointer;
        }
        p {
          font-size: 14px;
          line-height: 24px;
          padding-top: 5px;
          color: #ff0000;
        }
      }
      .pro-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 52px;
        font-size: 16px;
        color: #262626;
        padding: 0 24px;
        border-bottom: 1px solid #e8e8e8;
        cursor: pointer;
        i {
          display: block;
          transform: rotate(-90deg);
        }
      }
      .pro-bot {
        padding: 24px;
      }
      .comp-bot {
        display: flex;
        flex-wrap: wrap;
        .comp-msg {
          width: 50%;
          h4 {
            font-size: 36px;
            color: #333;
            line-height: 40px;
            padding-bottom: 10px;
            font-weight: 100;
          }
          span {
            font-size: 18px;
            color: #666;
          }
        }
        .comp-msg-t {
          margin-bottom: 40px;
        }
      }
      .hPro-bot {
        &-c {
          display: flex;
          align-items: center;
          min-height: 108px;
          &-l {
            width: 45%;
            font-size: 60px;
            line-height: 48px;
            color: #333;
            margin-right: 5%;
            text-align: center;
          }
          &-r {
            p {
              font-size: 36px;
              color: #333;
              display: flex;
              align-items: center;
              span {
                font-size: 14px;
                color: #666;
                margin-right: 16px;
              }
            }
          }
        }
        &-t {
          display: flex;
          justify-content: space-around;
          align-items: center;
          margin-top: 24px;
          .t-li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1;
            span:first-child {
              font-size: 14px;
              color: #666;
              padding-bottom: 14px;
            }
            span:last-child {
              font-size: 18px;
              color: #333;
            }
          }
          .t-li-c {
            border-left: 1px solid #e6e6e6;
            border-right: 1px solid #e6e6e6;
          }
        }
      }
      .common-bot {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img {
          margin-top: 40px;
        }
        span {
          display: block;
          font-size: 14px;
          color: #999;
          line-height: 50px;
        }
        .type-1 {
          color: #fe781d;
        }
        p {
          color: #ff0000;
          font-size: 14px;
        }
      }
    }
  }
}
/deep/ .info-Tip {
  .ivu-modal {
    top: 300px;
  }
  .ivu-modal-content {
    background-color: rgb(126, 0, 0);
    border-radius: 30px;
  }
  .ivu-modal-body {
    background-color: rgb(126, 0, 0);
    border-radius: 30px;
    padding: 60px 16px 40px;
  }
  .tip {
    text-align: center;
    font-size: 24px;
    color: #fff;
    font-weight: bold;
  }
  .tip-btn {
    position: absolute;
    left: 50%;
    margin-left: -90px;
    width: 180px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    text-align: center;
    background-color: rgb(64, 64, 64);
    font-size: 24px;
    cursor: pointer;
    border-radius: 10px;
  }
}
.ivu-dropdown {
  text-align: center;
}
/deep/.eh-top-r {
  .ivu-select-dropdown {
    left: 473px;
    width: auto;
  }
}

.dis_column {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
